import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Missing } from 'models/MissingModel';
import { ControlSession } from 'components/common/ControlSession';

const MissingList: React.FC = () => {
  const width = { date: 12, refno: 12, supplier: 20, amount: 12, comment:38 }
  const [formId, formName] = [Code.Form.Id.MISSING, Code.Form.Name.MISSING];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [missingData, setMissingData] = useState<Missing[]>([]); 
  const [selectedMissing, setselectedMissing] = useState<Missing | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const triggers = [pno, pageRows, search, activeId, userId, startDate, endDate];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Missing.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Missing.Id, 
        Name.Missing.Date, 
        Name.Supplier.Name, 
        Name.Missing.Amount, 
        Name.Missing.RefNumber, 
        Name.Missing.Comment
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(userId != 1 && { user_id: userId }),
      ...(startDate != '' && { start_date: startDate }),
      ...(endDate != '' && { end_date: endDate }),
    });
     
    await API.Data.List<Missing>(url, setMissingData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <ControlSession startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
              <Control.Dropdown title={Title.User} value={userId} options={userOptions} onChange={(value) => { setUserId(value);  callListData();  }} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, missingData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date],
                [Title.Refno, width.refno],
                [Title.Supplier, width.supplier], 
                [Title.Amount, width.amount, Code.Align.RIGHT], 
                [Title.Comment, width.comment],
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(missingData) && (
              <Control.Grid.Row>
                {missingData.map((missingData) => { return (
                <Control.Grid.Data<Missing> key={missingData.missing_id} itemKey={missingData.missing_key} data={missingData} setMenuPosition={setMenuPosition} setSelectedData={setselectedMissing} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={missingData.missing_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, missingData.missing_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Format.DateOnly(missingData.missing_date), width.date],
                    [missingData.missing_ref_number, width.refno],
                    [missingData.supplier_name, width.supplier],
                    [Utility.Format.Amount(missingData.missing_amount), width.amount, Code.Align.RIGHT],
                    [missingData.missing_comment, width.comment],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={missingData.missing_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={missingData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedMissing?.missing_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedMissing?.missing_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default MissingList;